// extracted by mini-css-extract-plugin
export default {"columns":"aXkhmS","responsiveLayout":"X1GXAD"};